import { render, staticRenderFns } from "./PageSizeSelect.vue?vue&type=template&id=2331b878"
import script from "./PageSizeSelect.vue?vue&type=script&lang=js"
export * from "./PageSizeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports